<template>
    <header id="banner" role="banner">
        <div id="heading" class="container">
            <div class="row">
                <div class="col-md-2">
                    <router-link class="sammio__logo" to="/" v-bind:aria-current-value="'false'">
                      <img :src="themeImagePath + '/sammio-logo.svg'" role="presentation" />
                      <span class="sr-only">{{ $t('sammio.navigation.logo_text')}}</span>

                    </router-link>
                </div>
                <div class="col-md-10" v-if="!getIsMobile">
                    <div class="header__wrapper">
                        <div class="header__column navigation-wrapper col-md-9">
                            <nav id="navigation" class="main-nav" :aria-label="$t('sammio.navigation.title')">
                                <ul class="main-nav-list list-unstyled" :aria-label="$t('sammio.navigation.site_pages')">
                                    <li>
                                        <router-link :to="{name: 'search', query: this.$router.currentRoute.query, params: {page_change: 'full'}}" exact>{{$t('sammio.search')}}</router-link>
                                    </li>
                                    <li>
                                      <router-link :to="{name: 'announcement', query: this.$router.currentRoute.query, params: {page_change: 'full'}}" exact>{{$t('sammio.announcement')}}</router-link>
                                    </li>
                                    <li>
                                        <router-link :to="{name: 'statutes_root', params: {page_change: 'full'} }">{{$t('sammio.statutes.title')}}</router-link>
                                    </li>
                                    <li class="d-none d-md-block">
                                        <router-link :to="{name: 'frequentsearches', params: {page_change: 'full'} }">{{$t('sammio.frequentsearches.title')}}</router-link>
                                    </li>
                                    <li>
                                        <router-link :to="{name: 'help', params: {page_change: 'full'} }">{{$t('sammio.help')}}</router-link>
                                    </li>
                                    <li class="main-nav-favourite-single">
                                        <router-link :to="{name: 'bookmarks', params: {page_change: 'full'} }">
                                          <span class="nav__item--bookmarks">{{$t('sammio.bookmarks.title')}} </span>
                                            <favourite-single v-if="bookmarksEmpty"></favourite-single>
                                            <favourite-single-highlight v-if="!bookmarksEmpty"></favourite-single-highlight>
                                            <div id="bookmarks-desktop-amount" class="sammio_bookmarks__count" v-if="!bookmarksEmpty">
                                              {{ bookmarkCount }} <span class="sr-only">{{$t('sammio.bookmarks.items')}}</span>
                                            </div>
                                        </router-link>
                                    </li>
                                </ul>
                            </nav>

                        </div>
                        <div class="header__column change-language-wrapper">
                            <sammio-change-language></sammio-change-language>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>
    
</template>

<script>
    import SammioChangeLanguage from './SammioChangeLanguage';
    import FavouriteSingle from "./icons/FavouriteSingle"
    import FavouriteSingleHighlight from "./icons/FavouriteSingleHighlight"
    import { mapGetters } from 'vuex'
    export default {
        name: "SammioHeader",
        components: {
            SammioChangeLanguage,
            FavouriteSingle,
            FavouriteSingleHighlight
        },
        computed: {
          ...mapGetters([
            'getLoaderStatus',
            'getLoadStatus',
            'getIsMobile'
          ]),
          themeImagePath () {
            return this.$store.state.themePath + 'images/sammio'
          },
          bookmarksEmpty() {
            return this.$store.getters.getBookmarks.length === 0
          },
          bookmarkCount() {
            if (this.$store.getters.getBookmarks.length > 0) {
              return this.$store.getters.getBookmarks.length
            }
          }
        }
    }
</script>

<style scoped>

</style>
